import { render, staticRenderFns } from "./select.vue?vue&type=template&id=5d8c185c&scoped=true&"
import script from "./select.vue?vue&type=script&lang=js&"
export * from "./select.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d8c185c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gitlab-runner/builds/3ztxUiUz/0/ifirst/dt-survey/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5d8c185c')) {
      api.createRecord('5d8c185c', component.options)
    } else {
      api.reload('5d8c185c', component.options)
    }
    module.hot.accept("./select.vue?vue&type=template&id=5d8c185c&scoped=true&", function () {
      api.rerender('5d8c185c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/FormGen/FormDesign/ItemConfig/select.vue"
export default component.exports